import * as React from 'react';
import Head from './Head';
import Header from './Header';
import Footer from './Footer';
import { useStaticQuery, graphql } from 'gatsby';
import { useTranslation } from 'react-i18next';

function Layout({ pageTitle, focus, children }) {
  const { t } = useTranslation(['cookies']);
  const result = useStaticQuery(
    graphql`
      {
        cms {
          sites {
            title
            logo {
              url
            }
            description
            url
            analyticsID
            footer
          }
        }
      }
    `,
  );

  const site = result.cms.sites.filter(
    (site) => site.url === process.env.GATSBY_FRONTEND_DOMAIN,
  )[0];

  const [focusMode, setFocusMode] = React.useState(false);

  React.useEffect(() => {
    setFocusMode(focus);
  }, [focus]);

  return (
    <>
      <Head pageTitle={pageTitle} site={site} />
      {!focusMode ? <Header siteTitle={site.title} logo={site.logo.url} /> : ''}

      <main>{children}</main>
      <Footer
        focusMode={focusMode}
        siteTitle={site.title}
        logo={site.logo.url}
        description={site.footer}
      />
    </>
  );
}
export default Layout;
